export default {
  degreePrograms: (state) => state.degreePrograms,
  userDegreeType:(state) => state.userDegreeType,
  militaryStatus: (state) => state.militaryStatus,
  degreeOptions: (state) => state.degreeOptions,
  courseModality: (state) => state.courseModality,
  regions: (state) => state.regions,
  schoolSize: (state) => state.schoolSize,
  hbcuOptions: (state) => state.hbcuOptions,
  userSdnAgree: (state) => state.userSdnAgree,
  discountNumber: (state) => state.discountNumber,
  notifications: (state) => state.notifications
};
